export default __webpack_public_path__ + "static/media/woman-team-3.8de4841b.avif";